document.addEventListener('DOMContentLoaded', function() {
    const baseUrl = "https://beta.api.oemsecrets.com/partsearch";
    const apiKey = "qhj2gtmfr6mxnnag2cn4aivp0fhzqrx0qpvz5w16lppmgowwwfh2hcqexmbdfe3m";

    function resetInventoryDisplay() {
        document.querySelectorAll('.distb-value').forEach(element => element.textContent = 'Loading...');
        document.querySelectorAll('tr[data-distributor]').forEach(row => row.style.display = 'none');
        document.querySelector('.modal__inner').style.visibility = 'hidden'; // Hide the inner container initially
        document.querySelector('tr[data-distributor="Tensility"]').style.display = 'none'; // Also hide Tensility row initially
    }

    function bindStockButtonEvents() {
        const stockButtons = document.querySelectorAll('[data-secondary-action="open-stocking-quick-view"]');
        
        stockButtons.forEach(button => {
            button.removeEventListener('click', handleStockButtonClick); // Remove existing listeners
            button.addEventListener('click', handleStockButtonClick); // Bind the stock click event
        });
    }
    
    // Re-bind events after search or pagination actions
    document.addEventListener('DOMContentLoaded', bindStockButtonEvents);
    document.addEventListener('click', function(event) {
        const target = event.target;
        if (target.closest('.pagination a') || target.closest('.search-results a')) {
            setTimeout(bindStockButtonEvents, 500); // Re-bind with a short delay
        }
    });

    function handleStockButtonClick(event) {
        resetInventoryDisplay();
    
        const productUrl = this.getAttribute('data-product-url');
        const partNumber = extractPartNumberFromUrl(productUrl);
    
        const productId = this.getAttribute('data-product-id');
        let productTags = '';
    
        if (productId) {
            const productTagsElement = document.getElementById(`product-tags-${productId}`);
            productTags = productTagsElement ? productTagsElement.getAttribute('data-tags').toLowerCase() : '';
    
            // Checking stock for Digi-Key, Master, and Arrow based on specific tags
            const isDigiKeyStocked = productTags.includes('digikey_stocked_y');
            const isArrowStocked = !productTags.includes('arrow_non-stocking_y');
            const isMasterStocked = !productTags.includes('master_stocking_n');
        } else {
            console.warn('Product ID not found for the clicked button.');
        }
    
        // Pass productTags directly to fetchInventoryData for further checks
        fetchInventoryData(partNumber, productTags);
        document.querySelector('.modal__loader').style.display = 'flex';
    }


    // Helper function to extract the part number correctly
    function extractPartNumberFromUrl(url) {
        // Remove any query parameters and return only the part number
        return url.split('/').pop().split('?')[0];
    }

    function fetchInventoryData(partNumber, productTags) {
        const url = new URL(baseUrl);
        url.search = new URLSearchParams({
            searchTerm: partNumber,
            apiKey: apiKey,
            currency: "USD"
        });

        fetch(url)
            .then(response => response.json())
            .then(data => {
                if (data.stock) {
                    // Pass productTags to updateInventoryDisplay
                    updateInventoryDisplay(data.stock, partNumber, productTags);
                } else {
                    console.error('No stock data found for:', partNumber);
                    document.querySelectorAll('.distb-value').forEach(element => element.textContent = 'No Data');
                }
                document.querySelector('.modal__loader').style.display = 'none'; // Hide loader once done
                document.querySelector('.modal__inner').style.visibility = 'visible'; // Show the modal content
            })
            .catch(error => {
                console.error('Error fetching inventory data for:', partNumber, error);
                document.querySelectorAll('.distb-value').forEach(element => element.textContent = 'Error');
                document.querySelector('.modal__loader').style.display = 'none'; // Hide loader on error
            });
    }

  function updateInventoryDisplay(stockData, partNumber, productTags) {
      const distributorVisibility = {
          '18780': false, // Digi-Key
          '16959': false, // Master Electronics
          '18681': false  // Arrow
      };
  
      let distributorsFound = false;
  
      stockData.forEach(item => {
          const distributorId = item.distributor.distributor_id;
          let isStocked = false;
  
          // Check for distributor-specific stocking logic
          if (distributorId === '18780') { // Digi-Key
              isStocked = productTags.includes('digikey-stocked_y');
          } else if (distributorId === '16959') { // Master Electronics
              isStocked = !productTags.includes('master_stocking_n');
          } else if (distributorId === '18681') { // Arrow
              isStocked = !productTags.includes('arrow_non-stocking_y');
          }
  
          // Additional checks for wire products from Digi-Key
          if (partNumber.startsWith('30-') && distributorId === '18780') {
              // Skip this item if it's not a spool or if the SKU doesn't match any of the valid formats
              if (
                  item.source_packaging !== 'Spool' ||
                  (
                      !item.sku.endsWith('305-ND') &&
                      !item.sku.endsWith('153-ND') &&
                      !item.sku.endsWith(`${partNumber}-ND`) // Check if SKU ends with part number + "-ND"
                  )
              ) {
                  return; // Skip this item
              }
          }
  
          if (item.manufacturer === 'Tensility International Corporation') {
              distributorVisibility[distributorId] = true;
              distributorsFound = true;
  
              const valueSelector = {
                  '18780': '.digikey-distb-value',
                  '16959': '.master-distb-value',
                  '18681': '.arrow-distb-value'
              }[distributorId];
  
              const buttonSelector = {
                  '18780': '.digikey-button-border a',
                  '16959': '.master-button-border a',
                  '18681': '.arrow-button-border a'
              }[distributorId];
  
              const rowSelector = {
                  '18780': 'tr[data-distributor="Digi-key"]',
                  '16959': 'tr[data-distributor="Master Electronics"]',
                  '18681': 'tr[data-distributor="Arrow"]'
              }[distributorId];
  
              const distbElement = document.querySelector(valueSelector);
              const buttonElement = document.querySelector(buttonSelector);
              const rowElement = document.querySelector(rowSelector);
  
              if (distbElement) {
                  if (isStocked) {
                      distbElement.textContent = item.quantity_in_stock !== null && item.quantity_in_stock !== undefined ? item.quantity_in_stock : '0';
                  } else {
                      distbElement.textContent = 'Non-stocking';
                  }
              }
  
              if (buttonElement && item.buy_now_url) {
                  buttonElement.href = item.buy_now_url;
              }
  
              if (rowElement) {
                  rowElement.style.display = '';
              }
          }
      });
  
      if (!distributorsFound) {
          const messageContainer = document.querySelector('.modal__inner tbody');
          const noDistributorMessage = document.createElement('tr');
          noDistributorMessage.innerHTML = '<td colspan="3" style="text-align: center; padding: 15px; width: 100%;">No distributors currently available. Please contact your local distributor to ask them to carry this product or contact us directly for pricing and lead time information.</td>';
          noDistributorMessage.classList.add('no-distributor-message');
          messageContainer.appendChild(noDistributorMessage);
      }
  
      // Hide rows with no distributor data
      Object.keys(distributorVisibility).forEach(id => {
          if (!distributorVisibility[id]) {
              const rowSelector = {
                  '18780': 'tr[data-distributor="Digi-key"]',
                  '16959': 'tr[data-distributor="Master Electronics"]',
                  '18681': 'tr[data-distributor="Arrow"]'
              }[id];
              const rowElement = document.querySelector(rowSelector);
              if (rowElement) {
                  rowElement.style.display = 'none';
              }
          }
      });
  }


    // Initial binding of stock buttons on page load
    bindStockButtonEvents();
});
